import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title max-sm-w-100" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_8 = {
  class: "d-flex flex-wrap gap-3 justify-content-end max-sm-w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_9 = { class: "svg-icon svg-icon-3" }
const _hoisted_10 = {
  type: "button",
  class: "btn btn-light-primary max-sm-flex-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_order_request_filter_drown"
}
const _hoisted_11 = { class: "svg-icon svg-icon-2" }
const _hoisted_12 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2" }
const _hoisted_14 = {
  key: 2,
  class: "me-0"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_17 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_18 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_22 = { class: "menu-item px-3" }
const _hoisted_23 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_27 = { class: "menu-item px-3" }
const _hoisted_28 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_29 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 opacity-75" }, null, -1)
const _hoisted_32 = { class: "card-title w-100" }
const _hoisted_33 = { class: "d-flex align-items-center position-relative my-1 w-100" }
const _hoisted_34 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_35 = ["placeholder"]
const _hoisted_36 = { class: "card-toolbar w-100" }
const _hoisted_37 = {
  class: "d-flex flex-wrap gap-3 justify-content-end w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_38 = { class: "svg-icon svg-icon-3" }
const _hoisted_39 = {
  type: "button",
  class: "btn btn-light-primary flex-1",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_40 = { class: "svg-icon svg-icon-2" }
const _hoisted_41 = { class: "me-0" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_44 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_45 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_46 = { class: "menu-item px-3" }
const _hoisted_47 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_49 = { class: "menu-item px-3" }
const _hoisted_50 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_51 = { class: "menu-item px-3" }
const _hoisted_52 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_54 = { class: "menu-item px-3" }
const _hoisted_55 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_56 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_57 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 opacity-75" }, null, -1)
const _hoisted_59 = { class: "card-title max-sm-w-100" }
const _hoisted_60 = { class: "d-flex align-items-center position-relative my-1 max-sm-w-100" }
const _hoisted_61 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_62 = ["placeholder"]
const _hoisted_63 = { class: "card-toolbar max-sm-w-100" }
const _hoisted_64 = {
  class: "d-flex flex-wrap gap-3 justify-content-end max-sm-w-100",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_65 = { class: "svg-icon svg-icon-3" }
const _hoisted_66 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_67 = { class: "svg-icon svg-icon-2" }
const _hoisted_68 = { class: "me-0" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_71 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_72 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_73 = { class: "menu-item px-3" }
const _hoisted_74 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_76 = { class: "menu-item px-3" }
const _hoisted_77 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_78 = { class: "menu-item px-3" }
const _hoisted_79 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_81 = { class: "menu-item px-3" }
const _hoisted_82 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_83 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_84 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 opacity-75" }, null, -1)
const _hoisted_86 = { class: "card-body pt-0 vip-table" }
const _hoisted_87 = { class: "text-nowrap" }
const _hoisted_88 = { class: "mw-150px fs-7 text-gray-400 text-line-clamp-1" }
const _hoisted_89 = { class: "fs-7 text-gray-400" }
const _hoisted_90 = { class: "w-100" }
const _hoisted_91 = { class: "d-flex align-items-center" }
const _hoisted_92 = { class: "svg-icon me-1" }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_95 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_96 = { class: "text-nowrap" }
const _hoisted_97 = { class: "text-nowrap" }
const _hoisted_98 = {
  key: 0,
  class: "text-nowrap",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_99 = {
  class: "btn btn-sm btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_100 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_101 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-230px py-4",
  "data-kt-menu": "true"
}
const _hoisted_102 = { class: "menu-item px-3" }
const _hoisted_103 = ["disabled", "onClick"]
const _hoisted_104 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_105 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_OrderRequestV2Item = _resolveComponent("OrderRequestV2Item")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _component_import_modal = _resolveComponent("import-modal")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid ps-14 max-sm-w-100",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.isMB)
              ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "btn btn-primary max-sm-flex-1",
                  to: "/merchant-order/order-request/0/add"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.add")), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_auth, { auth: ['add'] }]
                ])
              : _createCommentVNode("", true),
            (_ctx.store.getters.currentUser.user_type === 0)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  class: "w-200px",
                  modelValue: _ctx.options.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.options.type) = $event)),
                  onChange: _ctx.typeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.typeOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]))
              : _createCommentVNode("", true),
            _createVNode(_component_window_resize, null, {
              sm: _withCtx(() => [
                _createElementVNode("button", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                ])
              ]),
              lg: _withCtx(() => [
                _createElementVNode("button", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_FilterDropdown, {
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["onSubmitFilter", "onResetFilter"]),
            (!_ctx.isMB)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "btn btn-icon btn-bg-light btn-active-color-primary",
                    "data-kt-menu-trigger": "click",
                    "data-kt-menu-placement": "bottom-end",
                    "data-kt-menu-flip": "top-end",
                    disabled: 
                _ctx.disabledExportConfirmedTrack ||
                _ctx.disabledExportIncomingShipments ||
                _ctx.loading
              
                  }, [
                    (
                  _ctx.disabledExportConfirmedTrack ||
                  _ctx.disabledExportIncomingShipments
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                      : (_openBlock(), _createElementBlock("i", _hoisted_17))
                  ], 8, _hoisted_15),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_permission_common, { role: { auth: ['import'] } }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("common.import")), 1)
                        ]),
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.loading,
                    }]),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fileImport(1))),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#modal_import_order_request",
                            style: {"font-size":"normal"}
                          }, _toDisplayString(_ctx.t("orderRequest.importConfirmedTrack")), 3)
                        ]),
                        (0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-link px-3", {
                      disabled: _ctx.loading,
                    }]),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fileImport(2))),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_import_order_request",
                                style: {"font-size":"normal"}
                              }, _toDisplayString(_ctx.t("orderRequest.importIncomingShipments")), 3)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.t("common.export")), 1)
                        ]),
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["menu-link px-3", {
                      'opacity-50': _ctx.disabledExportConfirmedTrack || _ctx.loading,
                      'cursor-nodrop': _ctx.disabledExportConfirmedTrack || _ctx.loading,
                    }]),
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fileExportConfirmedTrack && _ctx.fileExportConfirmedTrack(...args))),
                            style: {"font-size":"normal"}
                          }, [
                            (_ctx.disabledExportConfirmedTrack && !_ctx.loading)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportConfirmedTrack")), 1)
                          ], 2)
                        ]),
                        (0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-link px-3", {
                      'opacity-50': _ctx.disabledExportIncomingShipments || _ctx.loading,
                      'cursor-nodrop':
                        _ctx.disabledExportIncomingShipments || _ctx.loading,
                    }]),
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fileExportIncomingShipments && _ctx.fileExportIncomingShipments(...args))),
                                style: {"font-size":"normal"}
                              }, [
                                (_ctx.disabledExportIncomingShipments && !_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportIncomingShipments")), 1)
                              ], 2)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _hoisted_31
                  ])
                ])), [
                  [_directive_auth, { auth: ['export', 'import'] }]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        (0)
          ? (_openBlock(), _createBlock(_component_window_resize, { key: 0 }, {
              sm: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.search) = $event)),
                      onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.searchItems())),
                      class: "form-control form-control-solid ps-14 w-100",
                      placeholder: _ctx.t('common.search')
                    }, null, 40, _hoisted_35), [
                      [_vModelText, _ctx.search]
                    ]),
                    _withDirectives(_createElementVNode("span", {
                      class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
                      style: {"cursor":"pointer"},
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
                    }, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ], 512), [
                      [_vShow, _ctx.search != '']
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                      class: "btn btn-primary flex-1",
                      to: "/merchant-order/order-request/0/add"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_38, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.add")), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_auth, { auth: ['add'] }]
                    ]),
                    _createVNode(_component_el_select, {
                      class: "w-200px",
                      modelValue: _ctx.options.type,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.options.type) = $event)),
                      onChange: _ctx.typeChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.typeOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("button", _hoisted_39, [
                      _createElementVNode("span", _hoisted_40, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                    ]),
                    _createVNode(_component_FilterDropdown, {
                      onSubmitFilter: _ctx.handleFilter,
                      onResetFilter: _ctx.handleFilterReset
                    }, null, 8, ["onSubmitFilter", "onResetFilter"]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-bg-light btn-active-color-primary",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end",
                        disabled: 
                    _ctx.disabledExportConfirmedTrack ||
                    _ctx.disabledExportIncomingShipments ||
                    _ctx.loading
                  
                      }, [
                        (
                      _ctx.disabledExportConfirmedTrack ||
                      _ctx.disabledExportIncomingShipments
                    )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                          : (_openBlock(), _createElementBlock("i", _hoisted_44))
                      ], 8, _hoisted_42),
                      _createElementVNode("div", _hoisted_45, [
                        _createVNode(_component_permission_common, { role: { auth: ['import'] } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.t("common.import")), 1)
                            ]),
                            _hoisted_48,
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-link px-3", {
                          disabled: _ctx.loading,
                        }]),
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.fileImport(1))),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_import_order_request",
                                style: {"font-size":"normal"}
                              }, _toDisplayString(_ctx.t("orderRequest.importConfirmedTrack")), 3)
                            ]),
                            (0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["menu-link px-3", {
                          disabled: _ctx.loading,
                        }]),
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.fileImport(2))),
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_import_order_request",
                                    style: {"font-size":"normal"}
                                  }, _toDisplayString(_ctx.t("orderRequest.importIncomingShipments")), 3)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.t("common.export")), 1)
                            ]),
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-link px-3", {
                          'opacity-50': _ctx.disabledExportConfirmedTrack || _ctx.loading,
                          'cursor-nodrop':
                            _ctx.disabledExportConfirmedTrack || _ctx.loading,
                        }]),
                                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.fileExportConfirmedTrack && _ctx.fileExportConfirmedTrack(...args))),
                                style: {"font-size":"normal"}
                              }, [
                                (_ctx.disabledExportConfirmedTrack && !_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_55))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportConfirmedTrack")), 1)
                              ], 2)
                            ]),
                            (0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["menu-link px-3", {
                          'opacity-50':
                            _ctx.disabledExportIncomingShipments || _ctx.loading,
                          'cursor-nodrop':
                            _ctx.disabledExportIncomingShipments || _ctx.loading,
                        }]),
                                    onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.fileExportIncomingShipments && _ctx.fileExportIncomingShipments(...args))),
                                    style: {"font-size":"normal"}
                                  }, [
                                    (_ctx.disabledExportIncomingShipments && !_ctx.loading)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_57))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportIncomingShipments")), 1)
                                  ], 2)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _hoisted_58
                      ])
                    ])), [
                      [_directive_auth, { auth: ['export', 'import'] }]
                    ])
                  ])
                ])
              ]),
              lg: _withCtx(() => [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("span", _hoisted_61, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.search) = $event)),
                      onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.searchItems())),
                      class: "form-control form-control-solid ps-14 max-sm-w-100",
                      placeholder: _ctx.t('common.search')
                    }, null, 40, _hoisted_62), [
                      [_vModelText, _ctx.search]
                    ]),
                    _withDirectives(_createElementVNode("span", {
                      class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
                      style: {"cursor":"pointer"},
                      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
                    }, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                    ], 512), [
                      [_vShow, _ctx.search != '']
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                      class: "btn btn-primary",
                      to: "/merchant-order/order-request/0/add"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_65, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.add")), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_auth, { auth: ['add'] }]
                    ]),
                    _createVNode(_component_el_select, {
                      class: "w-200px",
                      modelValue: _ctx.options.type,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.options.type) = $event)),
                      onChange: _ctx.typeChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.typeOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("button", _hoisted_66, [
                      _createElementVNode("span", _hoisted_67, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
                    ]),
                    _createVNode(_component_FilterDropdown, {
                      onSubmitFilter: _ctx.handleFilter,
                      onResetFilter: _ctx.handleFilterReset
                    }, null, 8, ["onSubmitFilter", "onResetFilter"]),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("button", {
                        class: "btn btn-icon btn-bg-light btn-active-color-primary",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end",
                        disabled: 
                    _ctx.disabledExportConfirmedTrack ||
                    _ctx.disabledExportIncomingShipments ||
                    _ctx.loading
                  
                      }, [
                        (
                      _ctx.disabledExportConfirmedTrack ||
                      _ctx.disabledExportIncomingShipments
                    )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_70))
                          : (_openBlock(), _createElementBlock("i", _hoisted_71))
                      ], 8, _hoisted_69),
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_permission_common, { role: { auth: ['import'] } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.t("common.import")), 1)
                            ]),
                            _hoisted_75,
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-link px-3", {
                          disabled: _ctx.loading,
                        }]),
                                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.fileImport(1))),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_import_order_request",
                                style: {"font-size":"normal"}
                              }, _toDisplayString(_ctx.t("orderRequest.importConfirmedTrack")), 3)
                            ]),
                            (0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["menu-link px-3", {
                          disabled: _ctx.loading,
                        }]),
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.fileImport(2))),
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_import_order_request",
                                    style: {"font-size":"normal"}
                                  }, _toDisplayString(_ctx.t("orderRequest.importIncomingShipments")), 3)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.t("common.export")), 1)
                            ]),
                            _hoisted_80,
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["menu-link px-3", {
                          'opacity-50': _ctx.disabledExportConfirmedTrack || _ctx.loading,
                          'cursor-nodrop':
                            _ctx.disabledExportConfirmedTrack || _ctx.loading,
                        }]),
                                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.fileExportConfirmedTrack && _ctx.fileExportConfirmedTrack(...args))),
                                style: {"font-size":"normal"}
                              }, [
                                (_ctx.disabledExportConfirmedTrack && !_ctx.loading)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_82))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportConfirmedTrack")), 1)
                              ], 2)
                            ]),
                            (0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["menu-link px-3", {
                          'opacity-50':
                            _ctx.disabledExportIncomingShipments || _ctx.loading,
                          'cursor-nodrop':
                            _ctx.disabledExportIncomingShipments || _ctx.loading,
                        }]),
                                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.fileExportIncomingShipments && _ctx.fileExportIncomingShipments(...args))),
                                    style: {"font-size":"normal"}
                                  }, [
                                    (_ctx.disabledExportIncomingShipments && !_ctx.loading)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_84))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.t("orderRequest.exportIncomingShipments")), 1)
                                  ], 2)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _hoisted_85
                      ])
                    ])), [
                      [_directive_auth, { auth: ['export', 'import'] }]
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_86, [
        _createVNode(_component_MBDatatablePlus, {
          class: "max-sm-text-nowrap",
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          order: "desc",
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-sub": _withCtx(({ row: item }) => [
            (_openBlock(), _createBlock(_component_OrderRequestV2Item, {
              key: item.id,
              isExpand: item.isExpand,
              id: item.id
            }, null, 8, ["isExpand", "id"]))
          ]),
          "cell-request_number": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_87, [
              _createVNode(_component_router_link, {
                to: 
                _ctx.getMerchantOrderRouterPath(_ctx.$route) + '/' + item.id + '/overview'
              ,
                class: "text-gray-800 text-hover-primary",
                onClick: _cache[24] || (_cache[24] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.request_number), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_el_popover, {
                placement: "top",
                width: "auto",
                trigger: "hover"
              }, {
                reference: _withCtx(() => [
                  _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.CommonArrayToString(item.__show.external_order_number)), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.CommonArrayToString(item.__show.external_order_number)), 1)
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          "cell-merchant_vendor": _withCtx(({ row: item }) => [
            _createVNode(_component_el_popover, {
              placement: "top",
              width: "auto",
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, _toDisplayString(item.__show.channel), 1),
                  _createElementVNode("div", _hoisted_89, _toDisplayString(item.__show.channel_type), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(item.__show.merchant), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          "cell-company": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.__show.settlement_entity_name), 1)
            ])
          ]),
          "cell-representative": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("span", _hoisted_92, [
                  _createVNode(_component_inline_svg_icon, {
                    style: {"width":"36px","height":"36px"},
                    src: "media/icons/duotune/communication/com006.svg"
                  })
                ]),
                _createElementVNode("div", null, _toDisplayString(item.__show.representative.name), 1)
              ])
            ])
          ]),
          "cell-confirm_deadline": _withCtx(({ row: item }) => [
            (item.request_expiry_date)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_ctx.getDiffDays(item.request_expiry_date) >= 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.getDiffDays(item.request_expiry_date) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_ctx.t("common.inDays", [
                          _ctx.getDiffDays(item.request_expiry_date),
                        ])), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.t("common.today")), 1))
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_95, _toDisplayString(_ctx.t("common.agoDays", [
                        _ctx.getLateDays(item.request_expiry_date),
                      ])), 1))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.request_expiry_date, "YYYY-MM-DD HH:mm")) + " ", 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "cell-qty": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_96, _toDisplayString(item.__show.qty), 1)
          ]),
          "cell-total": _withCtx(({ row: item }) => [
            _createElementVNode("div", _hoisted_97, _toDisplayString(item.__show.currency_code == "￥"
                ? _ctx.$currency.currency(
                    item.__show.total_amount,
                    2,
                    ".",
                    "",
                    item.__show.currency_code + " "
                  )
                : _ctx.$currency.currency(
                    item.__show.total_amount,
                    2,
                    ",",
                    ".",
                    item.__show.currency_code + " "
                  )), 1)
          ]),
          "cell-status": _withCtx(({ row: item }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge text-uppercase", _ctx.getOrderRequestProgressClass(item.order_progress)])
            }, _toDisplayString(item.__show.order_progress), 3)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            (item.order_progress !== _ctx.OrderRequestProgress.Draft)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  _createElementVNode("button", _hoisted_99, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.action")), 1),
                    _createElementVNode("span", _hoisted_100, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _createVNode(_component_router_link, {
                        to: 
                    _ctx.getMerchantOrderRouterPath(_ctx.$route) +
                    '/' +
                    item.id +
                    '/overview'
                  ,
                        onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
                        class: "menu-link px-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t("orderRequest.view")), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        disabled: item.downloadDisabled,
                        onClick: ($event: any) => (_ctx.fileExport(item.id, item)),
                        class: "menu-link px-3"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.t("orderRequest.downloadref")), 1)
                      ], 8, _hoisted_103)), [
                        [_directive_auth, { auth: ['export'] }]
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                  _createVNode(_component_router_link, {
                    to: 
                _ctx.getMerchantOrderRouterPath(_ctx.$route) + '/' + item.id + '/overview'
              ,
                    onClick: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"])),
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_105, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_import_modal, {
      onUpdateList: _ctx.updateList,
      uploadUrl: _ctx.options.uploadUrl
    }, null, 8, ["onUpdateList", "uploadUrl"])
  ], 64))
}